var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "bg-white shadow sm:rounded-lg my-5" }, [
        _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
          _c(
            "h3",
            { staticClass: "text-lg leading-6 font-medium text-gray-900" },
            [_vm._v(" " + _vm._s(_vm.title) + " ")]
          ),
          _c(
            "div",
            { staticClass: "mt-2 sm:flex sm:items-start sm:justify-between" },
            [
              _vm._m(0),
              _c(
                "div",
                {
                  staticClass:
                    "mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center"
                },
                [
                  _c(
                    "span",
                    { staticClass: "inline-flex rounded-md shadow-sm" },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150",
                          attrs: { type: "button" },
                          on: { click: _vm.openOptinModal }
                        },
                        [_vm._v(" View guide ")]
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ])
      ]),
      _vm.showModal
        ? _c("OptinOnboardingModal", {
            on: {
              close: function($event) {
                _vm.showModal = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "max-w-xl text-sm leading-5 text-gray-500" },
      [
        _c("p", [
          _vm._v(
            " Complete the steps in the guide and apply for approval. We will manually check your store checkout page to verify the changes. "
          )
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }